export const toggleItemInList = (list, item) => (
  list.includes(item)
    ? list.filter((value) => value !== item)
    : [...list, item]
);
